import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all() {
    return BackendAPI('get', ApiRoutes.corporation.all());
  },
  get(id) {
    return BackendAPI('get', ApiRoutes.corporation.get(id));
  },
  getSchools(corporationId) {
    return BackendAPI('get', ApiRoutes.corporation.getSchools(corporationId));
  },
  create(data) {
    return BackendAPI('post', ApiRoutes.corporation.create(), data);
  },
  update(id, data) {
    return BackendAPI('put', ApiRoutes.corporation.update(id), data);
  },
  changePassword(id, password) {
    let passData = { password: password };
    return BackendAPI('put', ApiRoutes.corporation.changePassword(id), passData);
  },
  frozen(id, data = {}) {
    return BackendAPI('put', ApiRoutes.corporation.frozen(id), data);
  },
  validateId(id) {
    return BackendAPI('get', ApiRoutes.corporation.validateId(id));
  },
};
